import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { BarChart } from '@mui/x-charts/BarChart';
import { useTheme } from '@mui/material/styles';

export default function BarBase({ title, data, layout = 'vertical' }) {
  const { palette } = useTheme();
  const paletteColors = [
    palette.primary.main,
    palette.warning.main,
    palette.error.main,
    palette.secondary.main,
    palette.success.main,
    palette.info.main,
  ];

  const tickOptions = {
    tickPlacement: 'middle',
    tickLabelPlacement: 'tick',
    tickLabelStyle: {
      fontSize: '14px',
      ...(layout === 'vertical'
        ? {
            angle: -15,
            textAnchor: 'end',
          }
        : {}),
    },
  };
  const layoutOptions = {
    vertical: {
      xAxis: [
        {
          data: data.map((entry) => entry.label),
          ...tickOptions,
          height: 80,
        },
      ],
      series: [
        {
          data: data.map((entry) => entry.value),
          colorGetter: ({ dataIndex }) =>
            paletteColors[dataIndex % paletteColors.length],
          barLabel: 'value',
        },
      ],
    },
    horizontal: {
      layout: 'horizontal',
      yAxis: [
        {
          data: data.map((entry) => entry.label),
          width: 200,
          ...tickOptions,
        },
      ],
      series: [
        {
          data: data.map((entry) => entry.value),
          colorGetter: ({ dataIndex }) =>
            paletteColors[dataIndex % paletteColors.length],
          barLabel: 'value',
        },
      ],
    },
  };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        textAlign: 'center',
      }}
    >
      <Typography sx={{ fontSize: '1.25rem' }}>{title}</Typography>
      <BarChart
        {...layoutOptions[layout]}
        width={layout === 'horizontal' ? 600 : 800}
        height={layout === 'horizontal' ? 300 : 200}
        borderRadius={10}
      />
    </Box>
  );
}
